import FolderIcon from '@mui/icons-material/Folder';
import LockIcon from '@mui/icons-material/Lock';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Button, Typography } from '@mui/material';
import { shortName } from '../tasks/taskUi';
import { dayAgo, fileCount } from './workFolderUi';

/** The folder page for a video or post, opened from this language's task. */
const FOLDER_WORDS = { POST: 'post', AUDIO: 'audio' };

export const workFolderUrl = (contentId, languageKey, contentType = 'VIDEO') =>
    `/work/${FOLDER_WORDS[contentType] || 'video'}/${encodeURIComponent(contentId)}${languageKey ? `?lang=${encodeURIComponent(languageKey)}` : ''}`;

const Line = ({ color, label, bold, right, locked }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5, gap: 1 }}>
        <Typography variant="body2" component="span" sx={{ display: 'inline-flex', alignItems: 'center', minWidth: 0 }}>
            <FolderIcon sx={{ fontSize: 16, mr: 0.75, color }} aria-hidden />
            {bold ? <b>{label}</b> : label}
        </Typography>
        <Typography variant="body2" color="text.secondary" component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
            {locked && <LockIcon sx={{ fontSize: 14 }} aria-hidden />}
            {locked ? `Locked · ${right}` : right}
        </Typography>
    </Box>
);

/**
 * The drawer's Shared folder section (rev6 6c, board 1): one line for the video's folder and
 * one for this language, with their file counts and the newest file in the language. Open
 * shared folder opens the folder page in a new tab, so the drawer and an upload both keep going.
 */
const WorkFolderSection = ({ task, summary }) => {
    if (!summary) return null;
    const title = task.contentTitle || `This ${FOLDER_WORDS[task.contentType] || 'video'}`;
    const latest = summary.latest;
    return (
        <Box sx={{ mt: 2.5 }}>
            <Typography variant="overline" component="div">
                Shared folder
            </Typography>
            <Line color="#90a4ae" label={`${title} (every language)`} right={fileCount(summary.videoCount)} locked={summary.videoLocked} />
            <Line color="primary.main" label={task.languageLabel} bold right={fileCount(summary.languageCount)} locked={summary.languageLocked} />
            {latest && (
                <Typography variant="caption" color="text.secondary" component="div" sx={{ pl: '22px' }}>
                    Latest: {latest.name} · {shortName(latest.uploadedBy)} · {dayAgo(latest.uploadedAt)}
                </Typography>
            )}
            <Button
                variant="outlined"
                size="small"
                sx={{ mt: 1 }}
                startIcon={<FolderIcon />}
                endIcon={<OpenInNewIcon sx={{ fontSize: '14px !important' }} />}
                href={workFolderUrl(task.contentId, task.waitingForFile ? null : task.languageKey, task.contentType)}
                target="_blank"
                rel="noopener"
            >
                Open shared folder
            </Button>
        </Box>
    );
};

export default WorkFolderSection;
